export enum CheckboxState {
  UNCHECKED = "UNCHECKED",
  CHECKED = "CHECKED",
  PARTIALLY_CHECKED = "PARTIALLY_CHECKED",
}
